<template>
  <div class="bg">
    <div class="gameStart">
      <img class="banner" src="../../assets/img/flex-bg-cover.svg" width="100%" alt="">
      <div class="content">
        <article class="animated zoomIn">
          <h2>新手村</h2>
          <img src="../../assets/img/flex-pirate-ship-sm.svg" alt="">
          <div class="info">
            <h4>每關附上對應教學網址，邊學邊玩，精通 flexbox</h4>
            <p>共有 20 道關卡</p>
          </div>
          <router-link class="btn btn-warning btn-lg rounded-0 start-btn" to="/simple">
            學好學滿
          </router-link>
        </article>
        <article class="animated zoomIn slow">
          <h2>老鳥村</h2>
          <img src="../../assets/img/flex-pirate-ship-lg.svg" alt="">
          <div class="info">
            <h4>計時大 PK，看誰最熟悉 flexbox，完成後成績可至排行榜觀看</h4>
            <p>共有 30 道關卡</p>
          </div>
          <button class="btn btn-warning btn-lg rounded-0 start-btn"
           data-toggle="modal" data-target="#login2" v-if="!user.id">
            馬上登入
          </button>
          <router-link class="btn btn-warning btn-lg rounded-0 start-btn"
            to="/contest" v-if="user.id">
            馬上挑戰
          </router-link>
        </article>
      </div>
    </div>
    <div class="modal fade" id="login2" tabindex="-1" role="dialog"
    aria-labelledby="loginLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <button class="btn btn-lg btn-outline-primary"
            @click="loginClick()" type="submit">
            <i class="fab fa-google"></i> 使用 google 繼續
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import firebase from 'firebase/app';

export default {
  name: 'Way',
  props: ['user'],
  data() {
    return {
      data: [],
    };
  },
  methods: {
    loginClick() {
      const fireAuth = firebase.auth();
      const vm = this;

      // Start a sign in process for an unauthenticated user.
      const provider = new firebase.auth.GoogleAuthProvider();
      provider.addScope('profile');
      provider.addScope('email');
      fireAuth.signInWithPopup(provider).then((result) => {
        const user = { user: result.user }; // 檢測
        $('#login2').modal('hide');
        firebase.database().ref(`users/${user.user.uid}`).set({
          email: user.user.email,
          displayName: user.user.displayName,
          photoURL: user.user.photoURL,
        });
        vm.$router.push('/contest');
        // console.log('登入成功');
      }).catch((ero) => {
        // 處理 帳號已經存在於其他登入方式時
        if (ero.code === 'auth/account-exists-with-different-credential') {
          // 取得當初此Email的登入方式
          const { email } = ero;
          console.log('google登入錯誤-使用者信箱：', email);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.bg{
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #00251a;
}
.gameStart{
  flex-direction: column;
  display: flex;
  width: 100%;
  min-width: 1024px;
  max-width: 1600px;
  background-color: #00251a;
  background-repeat: no-repeat;
  background-size: 1024px;
  background-position: center;
  position: fixed;
  justify-content: flex-end;
  align-items: center;
  .banner{
    max-height: 95vh;
  }
  .content{
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    height: 100%;
    article{
      background-color: rgba(#fff, 0.9);
      box-shadow: 1px 1px 10px rgba(#000, 0.5);
      width: 400px;
      height: 500px;
      margin: 0px 7px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      padding-top: 30px;
      overflow: hidden;
      position: relative;
      &:after{
        content: url('../../assets/img/flex-target-lg-2.svg');
        filter: brightness(0%);
        opacity: 0.1;
        position: absolute;
        bottom: 0px;
        right: 0;
        width: 500px;
        transition: all 0.5s ease-in;
      }
      &:first-child:after{
        content: url('../../assets/img/flex-target-sm-2.svg');
      }
      img{
        transition: all 0.5s ease-in-out;
        height: 100px;
        z-index: 1;
      }
      &:hover{
        img{
          transform: scale(1.4)
        }
        &:after{
          transform: rotate(40deg)
        }
      }
      .info{
        width: 80%;
      }
      h2{
        font-size: 36px;
        font-weight: bold;
      }
      p{
        margin: 15px 0;
        text-align: center;
        font-size: 14px;
        font-weight: bold;
        color: #00251a;
      }
      .start-btn{
        font-weight: bold;
        margin-top: 40px;
        width: 100%;
        position: relative;
        z-index: 1;
      }
    }
  }
}
</style>
